<template>
  <div id="app" class="mx-auto">
    <notifications />

    <template v-if="authState.isAuthenticated">
      <div class="clearfix">
        <b-button
          pill
          variant="outline-danger"
          class="float-right"
          @click="logout"
        >
          Logout
        </b-button>
      </div>
    </template>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  methods: {
    async logout() {
      await this.$auth.signOut();
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 5px;
  max-width: 960px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue